import { useState } from 'react';
import cn from 'classnames';
import { Collapse } from '@material-ui/core';
import { Typography, Card } from 'seagull';
import { WideArrowUpward, WideArrowDownward, Checkmark } from 'seagull/icons';
import { useStore, useStoreActions } from "../../../contexts";
import { selectors } from "../../../store/state-selectors";
import { CheckmarkWithSunCircle } from "./CheckmarkWithSunCircle";
import { ProgressBar } from "./ProgressBar/ProgressBar";
import { getStepsInfo } from "./BusinessOnboardingWidget.utils";
import { useStartKYC } from "../../../hooks/useStartKYCPersona";
import styles from "./BusinessOnboardingWidget.module.scss";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function BusinessOnboardingWidget(props) {
  const {
    className
  } = props;
  const userInfo = useStore(state => state.userInfo);
  const modifiedAServiceTemplate = useStore(selectors.user.modifiedAServiceTemplate);
  const hasSentAProposal = useStore(selectors.hasSentAProposal);
  const isMemberUser = useStore(selectors.user.isMemberUser);
  const videos = useStore(selectors.user.videos);
  const personaKYBStatus = useStore(s => s.personaKYBStatus.data);
  const {
    startKYC
  } = useStartKYC();
  const {
    logBI
  } = useStoreActions();
  const {
    KYB_VERIFICATION
  } = useFeatureFlags();
  const {
    steps: allSteps,
    numCompleted,
    isRequiredStepsCompleted
  } = getStepsInfo({
    videos,
    userInfo: userInfo || undefined,
    isMemberUser,
    personaKYBStatus: (personaKYBStatus === null || personaKYBStatus === void 0 ? void 0 : personaKYBStatus.status) || null,
    hasSentAProposal,
    modifiedAServiceTemplate,
    startKyc: startKYC,
    removeVerifyYourIdentityStep: KYB_VERIFICATION
  });
  const numSteps = allSteps.length;
  const allCompleted = numCompleted === numSteps;
  const [expanded, setExpanded] = useState(!isRequiredStepsCompleted);
  const [currentStepIdx, setCurrentStepIdx] = useState(() => {
    const idx = allSteps.findIndex(s => !s.complete);
    return idx < 0 ? 0 : idx;
  });
  const StepComponent = allSteps[currentStepIdx].component;
  return /*#__PURE__*/_jsx("div", {
    className: className,
    children: /*#__PURE__*/_jsxs(Card, {
      autoHeight: true,
      children: [/*#__PURE__*/_jsxs("button", {
        className: styles.toggle,
        "data-testid": "onboarding-widget-toggle-btn",
        onClick: () => setExpanded(!expanded),
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.titleWrapper,
          children: [/*#__PURE__*/_jsxs(Typography, {
            variant: "paragraph2",
            skin: allCompleted ? 'success' : 'standard',
            style: {
              display: 'flex',
              alignItems: 'center',
              gap: 8
            },
            "data-testid": "onboarding-widget-title",
            children: [allCompleted && /*#__PURE__*/_jsx("div", {
              className: styles.checkmark,
              children: /*#__PURE__*/_jsx(CheckmarkWithSunCircle, {})
            }), allCompleted ? 'Setup completed' : "Complete your setup (".concat(numCompleted, "/").concat(numSteps, ")")]
          }), !allCompleted && /*#__PURE__*/_jsx("div", {
            className: styles.progressBar,
            children: /*#__PURE__*/_jsx(ProgressBar, {
              total: numSteps,
              completed: numCompleted
            })
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: styles.toggleIcon,
          children: expanded ? /*#__PURE__*/_jsx(WideArrowUpward, {}) : /*#__PURE__*/_jsx(WideArrowDownward, {})
        })]
      }), /*#__PURE__*/_jsx(Collapse, {
        in: expanded,
        children: /*#__PURE__*/_jsxs("div", {
          className: styles.flexContainer,
          "data-testid": "onboarding-widget-expanded",
          children: [/*#__PURE__*/_jsx("div", {
            children: allSteps.map((s, idx) => !s.hide && /*#__PURE__*/_jsxs(Typography, {
              as: "button",
              skin: currentStepIdx === idx ? 'standard' : 'secondary',
              className: cn(styles.stepBtn, {
                [styles.selected]: currentStepIdx === idx
              }),
              "data-testid": "onboarding-widget-".concat(s.id, "-option"),
              onClick: () => {
                if (currentStepIdx !== idx) {
                  logBI(11200, {
                    step: s.id
                  });
                }
                setCurrentStepIdx(idx);
              },
              children: [s.label, s.complete ? /*#__PURE__*/_jsx(Typography, {
                as: "span",
                skin: "success",
                className: styles.stepBtnRight,
                "data-testid": "onboarding-widget-".concat(s.id, "-complete"),
                children: /*#__PURE__*/_jsx(Checkmark, {})
              }) : /*#__PURE__*/_jsx(Typography, {
                as: "span",
                variant: "paragraph3",
                skin: "disabled",
                className: styles.stepBtnRight,
                "data-testid": "onboarding-widget-".concat(s.id, "-duration"),
                children: !!s.minutes && "".concat(s.minutes, " min")
              })]
            }, s.id))
          }), /*#__PURE__*/_jsx("div", {
            className: styles.stepBodyContainer,
            children: /*#__PURE__*/_jsx(StepComponent, {
              userInfo: userInfo,
              isComplete: allSteps[currentStepIdx].complete,
              extraProps: allSteps[currentStepIdx].extraProps
            })
          })]
        })
      })]
    })
  });
}